import ConfigurationManager from '../configuration/ConfigurationManager';
import { overridesRegistryStore } from './OverridesRegistryStore';
import type { OverridableMethodsMap } from './types';

function isOverrideEnabled(): boolean {
  const confOverrides = ConfigurationManager.getProps('overrides');
  return confOverrides?.enable ?? false;
}

/**
 * Resolves a method override for a given API and method name.
 *
 * @param apiName    The override API (e.g. 'session', 'authProvider').
 * @param methodName The method within that API (e.g. 'isLoggedIn', 'refresh').
 * @returns The overridden method if available, otherwise undefined.
 */
export function resolveMethodOverride<
  D extends keyof OverridableMethodsMap,
  M extends keyof OverridableMethodsMap[D]
>(apiName: D, methodName: M): OverridableMethodsMap[D][M] | undefined {
  if (!isOverrideEnabled()) {
    return undefined;
  }

  return overridesRegistryStore.get(apiName, methodName);
}
